var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._g({tag:"component",staticClass:"rounded p-2 px-4 align-middle text-center hover:bg-opacity-90",class:{
    'opacity-50 cursor-default': _vm.$attrs.disabled,
    'inline-block': _vm.anchor
  }},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }